import { IUpdateEmpreendimentoUseCase } from "../../../presentation/useCases/update/update_empreendimento_use_case";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * UpdateEmpreendimentoUseCase
 */

export class UpdateEmpreendimentoUseCase implements IUpdateEmpreendimentoUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }

  async updateEmpreendimento(
    idEmpreendimento: number,
    descricao: string | null,
    apresentacao: string | null
  ): Promise<void> {
    await this.repository.updateEmpreendimento(
      idEmpreendimento,
      descricao,
      apresentacao
    )
  }

}
